import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'State/hooks';
import { setExpired } from 'State/subscriptionSlice';

// /subscribe/success polls the tenant-gated endpoints itself and redirects once they're
// confirmed clear, so a transient TENANT_EXPIRED hit mid-poll (webhook still catching up)
// must not surface this modal there — it would read as "the purchase didn't go through".
const SUPPRESSED_PATHS = ['/subscribe/success'];

export default function ExpiredModal() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isExpired = useAppSelector((state) => state.subscription.isExpired);
  const suppressed = SUPPRESSED_PATHS.includes(location.pathname);

  const handleClose = () => {
    dispatch(setExpired(false));
  };

  const handleSubscribe = () => {
    handleClose();
    navigate('/subscribe');
  };

  return (
    <Dialog open={isExpired && !suppressed} onClose={handleClose}>
      <DialogTitle>Trial Expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your trial has expired. Subscribe to a plan to keep using RevOptica.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Dismiss</Button>
        <Button variant="contained" onClick={handleSubscribe}>Subscribe</Button>
      </DialogActions>
    </Dialog>
  );
}